import React from "react";
import GetRequest from "../Services/APIRequest";
import Loading from "../Components/Loading";
import Error from "../Components/Error";
import { Link } from "react-router-dom";

const NotificationDashboard = () => {
  const distID = localStorage.getItem("distributorId");
  const userType = localStorage.getItem("userType");
  const userId = localStorage.getItem("userId");

  const endpoint =
    userType === "BPUser"
      ? `/Notification/GetListOfUnReadNotifications_TeamMember/${userId}`
      : `/Notification/ViewAllNotifications/${distID}`;

  const { data, error, isLoaded } = GetRequest(endpoint);

  if (!isLoaded) return <Loading />;
  if (error) return <Error data="Notifications" />;

  const notifications = data?.result || [];

  if (notifications.length === 0) {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header bg-primary">
                  <h3 className="card-title text-white">
                    <i className="fas fa-bell mr-2"></i> All Notifications
                  </h3>
                </div>
                <div className="card-body text-center py-5">
                  <div className="empty-state">
                    <i className="fas fa-bell-slash fa-4x text-muted mb-4"></i>
                    <h4 className="text-muted">No Notifications Found</h4>
                    <p className="text-muted">
                      You don't have any notifications at the moment.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header bg-primary">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="card-title text-white">
                    <i className="fas fa-bell mr-2"></i> All Notifications
                  </h3>
                  <span className="badge bg-light text-primary">
                    {notifications.length}{" "}
                    {notifications.length === 1
                      ? "Notification"
                      : "Notifications"}
                  </span>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  {notifications.map((item, index) => {
                    // Get notification type
                    const notificationType = item.informationType || "General";
                    const {
                      headerClass,
                      borderClass,
                      iconClass,
                      title,
                      buttonClass,
                    } = getNotificationTypeConfig(notificationType);

                    return (
                      <div
                        key={item.id || index}
                        className="col-lg-4 col-md-6 col-sm-12 mb-4"
                      >
                        <div
                          className={`card h-100 shadow-sm border-${borderClass}`}
                        >
                          <div
                            className={`card-header bg-${headerClass} text-white d-flex justify-content-between align-items-center`}
                          >
                            <div className="d-flex align-items-center">
                              <i className={`fas ${iconClass} mr-2`}></i>
                              <h6 className="card-title mb-0">{title}</h6>
                            </div>
                            <span className="badge bg-light text-dark">
                              {notificationType}
                            </span>
                          </div>
                          <div className="card-body">
                            <p className="card-text">{item.alertText}</p>
                            <div className="mt-3">
                              <small className="text-muted d-block">
                                <i className="fas fa-calendar-alt mr-1"></i>
                                {item.lifeTimeStartDate
                                  ? new Date(
                                      item.lifeTimeStartDate
                                    ).toLocaleDateString("en-IN", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })
                                  : "No date available"}
                              </small>
                            </div>
                          </div>
                          <div className="card-footer bg-transparent border-top-0">
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                {item.alertLink ? (
                                  <Link
                                    to={item.alertLink}
                                    className={`btn btn-sm btn-${buttonClass}`}
                                  >
                                    <i className="fas fa-eye mr-1"></i> View
                                    Details
                                  </Link>
                                ) : (
                                  <span className="text-muted small">
                                    No action required
                                  </span>
                                )}
                              </div>
                              <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => markAsRead(item.id)}
                                title="Mark as read"
                              >
                                <i className="fas fa-check"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="card-footer">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="notification-type-badges">
                    {/* <span className="badge bg-info mr-2">UpdatedPriceList</span>
                    <span className="badge bg-success mr-2">NewProduct</span>
                    <span className="badge bg-primary mr-2">General</span>
                    <span className="badge bg-secondary mr-2">Others</span> */}
                  </div>
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => window.location.reload()}
                  >
                    <i className="fas fa-sync-alt mr-1"></i> Refresh
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Notification type configuration based on your announcement types
const getNotificationTypeConfig = (type) => {
  const typeConfig = {
    UpdatedPriceList: {
      headerClass: "info",
      borderClass: "info",
      iconClass: "fa-chart-line",
      title: "Price List Updated",
      buttonClass: "info",
    },
    NewProduct: {
      headerClass: "success",
      borderClass: "success",
      iconClass: "fa-box",
      title: "New Product",
      buttonClass: "success",
    },
    General: {
      headerClass: "primary",
      borderClass: "primary",
      iconClass: "fa-bullhorn",
      title: "General Announcement",
      buttonClass: "primary",
    },
    Others: {
      headerClass: "secondary",
      borderClass: "secondary",
      iconClass: "fa-bell",
      title: "Notification",
      buttonClass: "secondary",
    },
  };

  // Default configuration for any other types
  return (
    typeConfig[type] || {
      headerClass: "warning",
      borderClass: "warning",
      iconClass: "fa-exclamation-triangle",
      title: "Notification",
      buttonClass: "warning",
    }
  );
};

// Mark as read function (you'll need to implement the API call)
const markAsRead = (notificationId) => {
  console.log("Mark as read:", notificationId);
  // Add your API call here
  // Example: APIRequest.post(`/Notification/MarkAsRead/${notificationId}`);
  alert(`Marked notification ${notificationId} as read`);
};

export default NotificationDashboard;
